<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="100px">
					<el-form-item label="处理状态">
						<el-select v-model="queryParams.state" placeholder="请选择处理状态">
							<el-option label="全部" value=""></el-option>
							<el-option label="未处理" :value="0"></el-option>
							<el-option label="已处理" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="编号/名称"><el-input v-model="queryParams.keyword" placeholder="请输入求助设备编号/名称"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark">
					<el-table-column prop="id" label="序号" width="60">
						<template slot-scope="scope">
							{{scope.$index+1}}
						</template>
					</el-table-column>
					<el-table-column prop="orderNo" label="求助设备编号" width="180"></el-table-column>
					<el-table-column prop="deviceTitle" label="求助设备名称"></el-table-column>
					<el-table-column prop="title" label="求助描述"></el-table-column>
					<el-table-column prop="contact" label="联系方式"></el-table-column>
					<el-table-column prop="teamTitle" label="所属团队"></el-table-column>
					<el-table-column prop="creatorName" label="提交人"></el-table-column>
					<el-table-column prop="createTime" label="提交时间"></el-table-column>
					<el-table-column prop="state" label="状态">
						<template slot-scope="scope">
							{{scope.row.state | formatState}}
						</template>
					</el-table-column>
					<el-table-column prop="operatorName" label="处理人"></el-table-column>
					<el-table-column prop="operateTime" label="处理时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="100">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleDetail(scope.row)" v-if="scope.row.state==1">查看</el-button>
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-else>处理</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 新增/修改 -->
		<el-dialog title="处理求助" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="120px">
				<el-form-item label="所属团队" prop="teamId">
					<el-select :disabled="true" v-model="addOrUpdateForm.teamId" style="width: 100%;" placeholder="请选择团队">
						<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="关联设备" prop="deviceId">
					<el-select :disabled="true" v-model="addOrUpdateForm.deviceId" ref="deviceSelect" filterable remote reserve-keyword placeholder="请选择设备" :remote-method="queryDeviceList"
						:loading="deviceLoading" @focus="deviceSelectFocus" :clearable="true">
						<el-option v-for="item in deviceList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="描述异常情况" prop="title">
					<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.title"></el-input>
				</el-form-item>
				<el-form-item label="联系方式" prop="contact"><el-input :disabled="true" type="text" v-model="addOrUpdateForm.contact"></el-input></el-form-item>
				<el-form-item label="处理记录" prop="description">
					<el-input type="textarea" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.description"></el-input>
				</el-form-item>
				<el-form-item label="上传照片">
					<span class="el-descriptions-item__content">
						<div>
							<ul class="el-upload-list el-upload-list--picture-card">
								<li tabindex="0" class="el-upload-list__item is-success" v-for="(image,index) in addOrUpdateForm.imageList" :key="index">
									<el-image style="width: 80px; height: 80px" :src="image" fit="fit" :preview-src-list="addOrUpdateForm.imageList"></el-image>
								</li>
							</ul>
						</div>
					</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleOperator">确 定</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog title="查看求助" :visible.sync="dialogDetailVisible" width="800px" :close-on-click-modal="false">
			<el-form :inline="false" :model="addOrUpdateForm" ref="addOrUpdateForm" label-width="120px">
				<el-form-item label="所属团队" prop="teamId">
					<el-select :disabled="true" v-model="addOrUpdateForm.teamId" style="width: 100%;" placeholder="请选择团队">
						<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="关联设备" prop="deviceId">
					<el-select :disabled="true" v-model="addOrUpdateForm.deviceId" ref="deviceSelect" filterable remote reserve-keyword placeholder="请选择设备" :remote-method="queryDeviceList"
						:loading="deviceLoading" @focus="deviceSelectFocus" :clearable="true">
						<el-option v-for="item in deviceList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="描述异常情况" prop="title">
					<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.title"></el-input>
				</el-form-item>
				<el-form-item label="联系方式" prop="contact"><el-input :disabled="true" type="text" v-model="addOrUpdateForm.contact"></el-input></el-form-item>
				<el-form-item label="处理结果" prop="state">{{addOrUpdateForm.state | formatState}}</el-input></el-form-item>
				<el-form-item label="处理记录" prop="description">
					<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.description"></el-input>
				</el-form-item>
				<el-form-item label="上传照片">
					<span class="el-descriptions-item__content">
						<div>
							<ul class="el-upload-list el-upload-list--picture-card">
								<li tabindex="0" class="el-upload-list__item is-success" v-for="(image,index) in addOrUpdateForm.imageList" :key="index">
									<el-image style="width: 80px; height: 80px" :src="image" fit="fit" :preview-src-list="addOrUpdateForm.imageList"></el-image>
								</li>
							</ul>
						</div>
					</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogDetailVisible = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		data() {
			return {
				url: 'mngr/maintenance/sim',
				name: 'SIM求助',
				teamList:[],
				deviceList:[],
				deviceLoading:false,
				dialogDetailVisible:false,
				queryDeviceParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				rules: {
					description: [{
							required: true,
							message: '请输入处理记录',
							trigger: 'blur'
						},
						{
							max: 500,
							message: '处理记录长度最长支持500',
							trigger: 'blur'
						}
					]
				}
			};
		},
		filters: {
			formatState(state) {
				if(state==0){
					return "未处理"
				}else{
					return "已处理"
				}
			}
		},
		methods: {
			handleDetail(row) {
				this.createUpdateForm(row);
				this.dialogDetailVisible = true;
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
					this.deviceList=[{
						id:newObj.deviceId,
						title:newObj.deviceTitle,
					}]
					this.teamList=[{
						id:newObj.teamId,
						name:newObj.teamTitle,
					}]
				} else {
					this.addOrUpdateForm = {};
				}
				
			},
			beforeUpdate() {},
			queryTeamList() {
				this.$http({
					method: 'POST',
					url: 'team/query',
					data: {
						currentPage: 1,
						pageSize: 100,
						defaultSort: {
							order: 'desc',
							prop: 'id'
						}
					},
				}).then((res)=> {
					this.teamList = res.data.data;
				})
			},
			handleOperator() {
				this.beforeValidate()
				//添加/保存
				this.$refs['addOrUpdateForm'].validate(valid => {
					if (valid) {
						this.beforeUpdate();
						let that = this;
						let url = '/operator';
						this.$http({
								method: 'POST',
								url: that.url + url,
								data: that.addOrUpdateForm
							})
							.then(function(res) {
								if (res.data.errorCode == '0000') {
									that.successMessage('系统提示', '操作成功');
									that.dialogVisible = false;
									that.getList();
								}
							})
					}
				});
			},
		},
		mounted: function() {
			this.queryTeamList();
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	.left {
		background: url(../../../assets/img/left.png);
		background-size: 100% 100%;
		width: 340px;
		height: 320px;
		float: left;
	}

	.center {
		float: left;
		margin-left: 15px;
		width: 220px;
		text-align: center;
		font-size: 18px;
		margin-top: 15px;
		position: relative
	}

	.wifi {
		position: absolute;
		right: 40px;
		top: 244px;
		background: url(../../../assets/img/wifi.png);
		background-size: 100% 100%;
		width: 43px;
		height: 31px;
	}

	.right {
		float: left;
		width: 520px;
	}
	
	/deep/ .el-upload-list--picture-card .el-upload-list__item {
		width: 80px;
		height: 80px;
	}
	
	/deep/ .el-upload--picture-card {
		width: 80px;
		height: 80px;
		line-height: 90px;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/order/maintenanceSimManager.vue